class GTM {

    // Append all custom event names here
    static CUSTOM_EVENT_PAGEVIEW = 'custom_page_view';

    gtmScriptId = 'gtm-ga4-script';
    gtmTagId = 'GTM-P5ZRP97'; // Default
    gtmUrl = 'https://www.googletagmanager.com/gtm.js';

    constructor(gtmTagId) {
        if(gtmTagId != null && gtmTagId.length > 0) this.gtmTagId = gtmTagId;
    }

    insertGTMScript() {
        let scriptObject = top.document.createElement('script');
        scriptObject.setAttribute('id', this.gtmScriptId);

        let scriptCodes = "";
        scriptCodes += "(function(w,d,s,l,i){";
        scriptCodes += "w[l] = w[l] || [];";
        scriptCodes += "w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});";
        scriptCodes += "var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : '';";
        scriptCodes += "j.async = true;";
        scriptCodes += "j.src = '" + this.gtmUrl + "?id=' + i + dl;";
        scriptCodes += "f.parentNode.insertBefore(j, f);";
        scriptCodes += "})(window, document, 'script', 'dataLayer', '" + this.gtmTagId + "');";

        let inlineScript = top.document.createTextNode(scriptCodes);
        scriptObject.appendChild(inlineScript);

        let body = top.document.body || top.document.getElementsByTagName('body')[0];
        body.appendChild(scriptObject);
    }

    execute() {
        this.insertGTMScript();
    }

    static triggerEvent(eventType, absoluteUrl, pagePath, pageTitle) {
        if(top.dataLayer && typeof top.dataLayer.push === 'function'){
            top.dataLayer.push({
                event: eventType, 
                eventModel: {
                    page_location: absoluteUrl,
                    page_path: pagePath,
                    page_title: pageTitle
                }
            });
        }
    }
}

export default GTM;
